(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var STORE_KEY = 'vss_utm';

  function readStoredUtm() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || null; } catch (e) { return null; }
  }

  // Capture UTM params on landing, persist for the session
  function captureUtm() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    var any = false;
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { found[k] = v.slice(0, 255); any = true; }
    });
    if (any) {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(found)); } catch (e) { /* private mode */ }
      return found;
    }
    return readStoredUtm();
  }

  // Persist UTM onto the cart as attributes so they reach the order
  function syncCartAttributes(utm) {
    if (!utm) return;
    try { if (sessionStorage.getItem('vss_utm_synced') === '1') return; } catch (e) {}
    var attributes = {};
    UTM_KEYS.forEach(function (k) { if (utm[k]) attributes[k] = utm[k]; });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      if (r.ok) { try { sessionStorage.setItem('vss_utm_synced', '1'); } catch (e) {} }
    }).catch(function () {});
  }

  // Re-sync after any add-to-cart so a fresh cart carries the attributes too
  function watchCartForms(utm) {
    if (!utm) return;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart/add') !== -1) {
        try { sessionStorage.removeItem('vss_utm_synced'); } catch (err) {}
        setTimeout(function () { syncCartAttributes(utm); }, 1500);
      }
    }, true);
  }

  // Event fan-out to whichever vendors are loaded
  function track(eventName, params) {
    params = params || {};
    if (typeof window.gtag === 'function') window.gtag('event', eventName, params);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, params);
  }
  window.vssTrack = track;

  function funnelContext() {
    var f = document.body.getAttribute('data-funnel');
    return f ? { funnel: f } : {};
  }

  // Delegated CTA clicks
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-funnel-cta]');
    if (!cta) return;
    var params = funnelContext();
    params.cta = cta.getAttribute('data-funnel-cta') || 'cta';
    track('funnel_cta_click', params);
  });

  // Email capture submits
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) return;
    var capture = form.closest('[data-funnel-capture]');
    if (!capture) return;
    var params = funnelContext();
    params.capture = capture.getAttribute('data-funnel-capture') || 'capture';
    track('funnel_email_capture', params);
  }, true);

  // Scroll depth 50 / 90, once each
  function watchScrollDepth() {
    var fired = {};
    var marks = [50, 90];
    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = ((window.scrollY || doc.scrollTop) / scrollable) * 100;
      marks.forEach(function (m) {
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          var params = funnelContext();
          params.depth = m;
          track('funnel_scroll_depth', params);
        }
      });
      if (fired[50] && fired[90]) window.removeEventListener('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var utm = captureUtm();
  syncCartAttributes(utm);
  watchCartForms(utm);
  watchScrollDepth();
})();
